"use client"

import { use$ } from "@legendapp/state/react"
import { useEffect } from "react"
import { usePostHog } from "posthog-js/react"
import { syncStore$ } from "@/stores/sync.v2.store"

export function usePosthogIdentified() {
  const posthog = usePostHog()

  const user = use$(syncStore$.userStatus)

  useEffect(() => {
    if (user) {
      // If the user is already identified, don't identify them again
      if (posthog._isIdentified()) {
        console.log("User is already identified, skipping posthog identify")
        return
      }

      console.log(`Identifying ${user.id.toString()} in posthog`)
      posthog.identify(user.id.toString(), {
        displayName: `${user.name} ${user.lastName}`,
        email: user.email,
        companyName: user.companyName,
        account: user.accountId,
        status: user.accountState,
        seats: user.accountSeats,
        signupChannel: user.accountSignupChannel,
        signupPlan: user.accountSignupPlan,
        smsOptIn: user.smsOptIn,
        emailMarketingOptIn: user.emailMarketingOptIn,
      })
    } else {
      console.log("Resetting posthog since user is not logged in")
      posthog.reset()
    }
  }, [user, posthog])
}
